<mat-form-field style="color:black;">
    <mat-label>{{'TIMEZONE.NAME' | translate}}</mat-label>
    <mat-select (selectionChange)="changeTimeZone($event)" [(value)]="selectedOption" class="virtual-scroll">
            <mat-option *ngFor="let timeZone of utcCollection"  [value]="timeZone" class="example-item">
                {{timeZone}}
                <div *ngIf="!timeZone">Loading...</div>
            </mat-option>
    </mat-select>
</mat-form-field>